import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import { isEqual } from 'lodash';

import { EditableType } from '@/types/sensor/sensorInstallation.types';

import { useSensorEditingContext } from './SensorEditingContext';
import SensorFormNavigationArrows from './SensorFormNavigationArrows';
import { SensorPositionForm } from './sensors';

export default function SensorEditingForm<T extends EditableType>() {
  const { currentStep, currentSubStep } = useSensorEditingContext<T>();

  if (isEqual(currentStep.component, SensorPositionForm)) {
    return <SensorPositionForm />;
  }

  return (
    <CockpitFormLayout
      title={`components.sensorInstallation.form.${currentStep.label}`}
      subTitle={currentSubStep?.label ? `components.sensorInstallation.form.${currentSubStep.label}` : undefined}
      footer={<SensorFormNavigationArrows />}
    >
      {currentSubStep ? <currentSubStep.component /> : <currentStep.component />}
    </CockpitFormLayout>
  );
}
